import { withTranslation } from "react-i18next";
import {
  displayNameGeneric,
  formatDate,
  formatSecondsToHMS,
} from "./common.jsx";
import ReactTooltip from "react-tooltip";

import "./style.css";
const tabcollegue = JSON.parse(localStorage.getItem("tabcollegue") ?? null);

function QueueGroupBox(props) {
  const { t, item, type } = props;
  const caller = displayNameGeneric(
    item.src,
    tabcollegue,
    (col, val) => col.poste == val,
  );

  const called = displayNameGeneric(
    item.dst,
    tabcollegue,
    (col, val) => col.poste == val,
  );
  const rappel = item.rappel_traite_par
    ? displayNameGeneric(
        item.rappel_traite_par,
        tabcollegue,
        (col, val) => col.poste == val,
      )
    : null;
  // Generic avatar renderer
  const renderAvatar = (displayName) => {
    return displayName?.nom ? (
      <span className="dark:bg-gray-700 inline-flex items-center justify-center h-9 w-9 rounded-full bg-gray-400">
        <span className="text-base font-medium leading-none text-white">
          {displayName.nom?.[0]?.toUpperCase()}
        </span>
      </span>
    ) : (
      <span className="dark:bg-gray-700 inline-block h-9 w-9 rounded-full overflow-hidden bg-gray-200">
        <svg
          className="h-full w-full text-gray-400"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"></path>
        </svg>
      </span>
    );
  };
  return (
    <tr className="dark:bg-gray-900 dark:text-white transition-all">
      {/* indicator */}
      <td className="px-4 py-4 whitespace-no-wrap border-b border-gray-200 dark:border-gray-700">
        {" "}
        <DisplayProcessingStatus type={type} item={item} t={t} />
      </td>
      {/* caller */}
      <td className="py-3 px-4 whitespace-no-wrap border-b border-gray-200 dark:border-gray-700">
        <div className="flex items-center">
          <div className="flex-shrink-0 h-10 w-10">
            <span className="inline-block relative">
              {renderAvatar(caller)}
            </span>
          </div>
          <div className="ml-1">
            <div className="text-xs leading-5 font-medium text-gray-900 dark:text-white transition-all">
              {caller?.nom}
              <div className="text-xs leading-5 text-gray-500">{item.src}</div>
            </div>
          </div>
        </div>
      </td>
      {/* called */}
      <td className="py-3 px-4 whitespace-no-wrap border-b border-gray-200 dark:border-gray-700">
        <div className="flex items-center">
          {item.dst ? (
            <>
              <div className="flex-shrink-0 h-10 w-10">
                <span className="inline-block relative">
                  {renderAvatar(called)}
                </span>
              </div>
              <div className="ml-1">
                <div className="text-xs leading-5 font-medium text-gray-900 dark:text-white transition-all">
                  {called?.nom}
                  <div className="text-xs leading-5 text-gray-500">
                    {item.dst}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="w-full text-center">-</div>
          )}
        </div>
      </td>
      {/* Name group / queue */}

      <td className="py-3 px-4   border-b border-gray-200 dark:border-gray-700">
        <div className="text-xs leading-5 text-gray-500 ml-2 inline-block dark:text-gray-300">
          {item[type === "group" ? "nom_groupeappel" : "nom_fileattente"]}
        </div>
        <div className="text-xs leading-5 font-bold text-gray-500 ml-2 inline-block dark:text-gray-300">
          ({item[type === "group" ? "num_groupeappel" : "num_fileattente"]})
        </div>
      </td>
      {/* call date */}
      <td className="py-3 px-4 whitespace-no-wrap border-b border-gray-200 dark:border-gray-700">
        <div className="text-xs leading-5 text-gray-500 ml-2 inline-block dark:text-gray-300">
          {formatDate(item.calldate_start, t)}
        </div>
      </td>
      {/* call duration */}

      <td className="px-6 py-3 whitespace-no-wrap border-b border-gray-200 dark:border-gray-700">
        <span className="dark:bg-gray-600 dark:text-white px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
          {formatSecondsToHMS(item.billsec)}
        </span>
      </td>
      {/* sda */}
      <td className="py-3 px-4 whitespace-no-wrap border-b border-gray-200 dark:border-gray-700">
        <div className="text-xs leading-5 text-gray-500 ml-2 inline-block dark:text-gray-300">
          {item.sda ?? "-"}
        </div>
      </td>
      {/* ring sec */}

      <td className="px-6 py-3 whitespace-no-wrap border-b border-gray-200 dark:border-gray-700">
        <span className="dark:bg-gray-600 dark:text-white px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
          {formatSecondsToHMS(item.ringingsec)}
        </span>
      </td>
      {/* treated by */}

      <td className="py-3 px-4 whitespace-no-wrap border-b border-gray-200 dark:border-gray-700">
        {rappel ? (
          <div className="flex items-center">
            <div className="flex-shrink-0 h-10 w-10">
              <span className="inline-block relative">
                {renderAvatar(rappel)}
              </span>
            </div>
            <div className="ml-1">
              <div className="text-xs leading-5 font-medium text-gray-900 dark:text-white transition-all">
                {rappel?.nom}
                <div className="text-xs leading-5 text-gray-500">
                  {rappel.poste}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="w-full text-center">-</div>
        )}
      </td>
      {/* status treated*/}

      <td className="py-3 px-4 whitespace-no-wrap border-b border-gray-200 dark:border-gray-700">
        {item.rappel_etat_traite === "TREATED" ? (
          <div className="text-xs leading-5 text-green-500 ml-2 inline-block dark:text-green-400">
            {t("TREATED")}
          </div>
        ) : (
          <div className="text-xs leading-5 text-red-500 ml-2 inline-block dark:text-red-400">
            {t("UNTREATED")}
          </div>
        )}
      </td>
      {/* rappel date*/}

      <td className="py-3 px-4 whitespace-no-wrap border-b border-gray-200 dark:border-gray-700">
        <div className="text-xs w-full leading-5 text-gray-500  inline-block dark:text-gray-300">
          {formatDate(item.rappel_calldate, t)}
        </div>
      </td>
    </tr>
  );
}
function HeaderQueueGroupBox(props) {
  const { t, type } = props;

  return (
    <thead>
      <tr className="">
        <th className=" w-12 header-table">&nbsp;</th>
        <th className="header-table">{t("caller")}</th>
        <th className="header-table">{t("called")}</th>
        <th className="header-table">
          {type === "group" ? t("Nom.group") : t("Nom.queue")}
        </th>
        <th className="header-table">{t("calldate")}</th>
        <th className="header-table">{t("callduree")}</th>
        <th className="header-table">{t("receptionNumber")}</th>
        <th className="header-table">{t("ringDuration")}</th>
        <th className="header-table">{t("treatedBy")}</th>

        <th className="header-table">{t("recallStatus")}</th>

        <th className="header-table">{t("recallDate")}</th>
      </tr>
    </thead>
  );
}

function DisplayProcessingStatus(props) {
  const { t, item, type } = props;
  let valueToCompare = false;

  if (type === "group") {
    valueToCompare = item.disposition === "ANSWERED";
  } else {
    if (item.etat_queue === "1") {
      valueToCompare = true;
    } else {
      if (item.etat_rappel === "oui") {
        valueToCompare = item.rappel_disposition === "ANSWERED";
      } else {
        valueToCompare = false;
      }
    }
  }
  return (
    <div data-tip data-for={`treated_disposition-${item.id}`}>
      <ReactTooltip
        id={`treated_disposition-${item.id}`}
        place="bottom"
        effect="solid"
      >
        <div>{valueToCompare ? t("TREATED") : t("UNTREATED")}</div>
      </ReactTooltip>
      {valueToCompare ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="h-6 w-6 text-green-500"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke="currentColor"
          className="h-6 w-6 text-red-500"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>
      )}
    </div>
  );
}
const TranslatedQueueGroupBox = withTranslation("common")(QueueGroupBox);
const TranslatedHeaderQueueGroupBox =
  withTranslation("common")(HeaderQueueGroupBox);

export { TranslatedQueueGroupBox, TranslatedHeaderQueueGroupBox };
